// app/javascript/controllers/button_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "buttonContainer"]
  static values = {
    buttonClass: { type: String, default: "btn btn-outline-info btn-sm me-2 mb-2" },
    activeClass: { type: String, default: "active" }
  }
  
  connect() {
    console.log("Button Select Controller connected");
    if (this.hasSelectTarget) {
      this.createButtonsFromSelect()
      // Hide the original select but keep it in the DOM for form submission
      this.selectTarget.style.display = 'none'
    }
  }
  
  createButtonsFromSelect() {
    // Get or create a button container
    let buttonContainer;
    
    if (this.hasButtonContainerTarget) {
      // Use existing container but clear it
      buttonContainer = this.buttonContainerTarget;
      buttonContainer.innerHTML = ''; // Clear existing buttons
    } else {
      // Create a new container
      buttonContainer = document.createElement('div');
      buttonContainer.classList.add('button-select-container', 'd-flex', 'flex-wrap');
      buttonContainer.setAttribute('data-button-select-target', 'buttonContainer');
      this.selectTarget.insertAdjacentElement('afterend', buttonContainer);
      
      // We need to initialize the controller again to recognize the new target
      // Wait for the DOM to update
      setTimeout(() => this.connect(), 0);
      return; // Exit and let the reconnect handle creating buttons
    }
    
    // Create buttons for each option
    const options = Array.from(this.selectTarget.options);
    options.forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.classList.add(...this.buttonClassValue.split(' '));
      button.textContent = option.text.trim();
      button.dataset.value = option.value;
      button.dataset.action = 'click->button-select#selectOption';
      
      // If this option is selected, add active class
      if (option.selected) {
        button.classList.add(...this.activeClassValue.split(' '));
      }
      
      buttonContainer.appendChild(button);
    })
  }
  
  selectOption(event) {
    const selectedValue = event.currentTarget.dataset.value
    
    // Update the actual select element
    this.selectTarget.value = selectedValue
    
    // Trigger change event on select so other controllers can respond
    const changeEvent = new Event('change', { bubbles: true })
    this.selectTarget.dispatchEvent(changeEvent)
    
    // Update button styling - only if we have the target
    if (this.hasButtonContainerTarget) {
      this.buttonContainerTarget.querySelectorAll('button').forEach(button => {
        if (button.dataset.value === selectedValue) {
          button.classList.add(...this.activeClassValue.split(' '))
        } else {
          button.classList.remove(...this.activeClassValue.split(' '))
        }
      })
    }
  }
  
  // If the select changes from another source, update the buttons
  updateButtons() {
    // Only proceed if we have the button container target
    if (!this.hasButtonContainerTarget) return;
    
    const selectedValue = this.selectTarget.value
    this.buttonContainerTarget.querySelectorAll('button').forEach(button => {
      if (button.dataset.value === selectedValue) {
        button.classList.add(...this.activeClassValue.split(' '))
      } else {
        button.classList.remove(...this.activeClassValue.split(' '))
      }
    })
  }
}